var _path;
import * as React from "react";
import { SvgIcon } from '@mui/material';
var SvgArrowIcon = function SvgArrowIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9H3.75M9 3.75L3.75 9 9 14.25",
    stroke: "#000",
    strokeWidth: 1.332,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgArrowIcon;